import { FC, useState } from 'react'

import { EuiFlyoutHeader, EuiFlyoutBody, EuiFlyoutFooter, EuiTitle, EuiButton, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiCheckbox } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

export interface AIPlanClientPreviewTabsSettings {
  showExecutiveSummary: boolean
  showMarketAnalysis: boolean
  showPersonas: boolean
  showMediaPlan: boolean
  showProjections: boolean
}

export interface AIPlanClientPreviewTabsFlyoutProps {
  currentSettings: AIPlanClientPreviewTabsSettings
  onSave: (settings: AIPlanClientPreviewTabsSettings) => void
  onClose: () => void
  isLoading: boolean
}

const AIPlanClientPreviewTabsFlyout: FC<AIPlanClientPreviewTabsFlyoutProps> = ({ currentSettings, onSave, onClose, isLoading }) => {
  const [showExecutiveSummary, setShowExecutiveSummary] = useState(currentSettings.showExecutiveSummary ?? true)
  const [showMarketAnalysis, setShowMarketAnalysis] = useState(currentSettings.showMarketAnalysis ?? true)
  const [showPersonas, setShowPersonas] = useState(currentSettings.showPersonas ?? true)
  const [showMediaPlan, setShowMediaPlan] = useState(currentSettings.showMediaPlan ?? true)
  const [showProjections, setShowProjections] = useState(currentSettings.showProjections ?? true)

  const handleSave = () => {
    onSave({
      showExecutiveSummary,
      showMarketAnalysis,
      showPersonas,
      showMediaPlan,
      showProjections
    })
  }

  return (
    <AcFlyout onClose={onClose}>
      <EuiFlyoutHeader>
        <EuiTitle size='m'>
          <h2>Edit Client Preview Tabs</h2>
        </EuiTitle>
      </EuiFlyoutHeader>

      <EuiFlyoutBody>
        <EuiFormRow fullWidth>
          <EuiCheckbox id='showExecutiveSummary' label='Executive Summary' checked={showExecutiveSummary} onChange={e => setShowExecutiveSummary(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>

        <EuiFormRow fullWidth>
          <EuiCheckbox id='showMarketAnalysis' label='Analysis & Strategy' checked={showMarketAnalysis} onChange={e => setShowMarketAnalysis(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>

        <EuiFormRow fullWidth>
          <EuiCheckbox id='showPersonas' label='Personas' checked={showPersonas} onChange={e => setShowPersonas(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>

        <EuiFormRow fullWidth>
          <EuiCheckbox id='showMediaPlan' label='Media Plan' checked={showMediaPlan} onChange={e => setShowMediaPlan(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>

        <EuiFormRow fullWidth>
          <EuiCheckbox id='showProjections' label='Projections' checked={showProjections} onChange={e => setShowProjections(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>
      </EuiFlyoutBody>

      <EuiFlyoutFooter>
        <EuiFlexGroup justifyContent='flexStart' gutterSize='l'>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose} disabled={isLoading}>
              Cancel
            </EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={handleSave} isLoading={isLoading} disabled={isLoading}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default AIPlanClientPreviewTabsFlyout
